import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { UserContext } from "../../context/UserContextProvider";

/**
 * Instructions table for VA-sponsored EHR/CPOE Evaluation Tool (2025 version).
 * Currently duplicates the content of the LeapFrog 2025 instructions table.
 */
const InstructionsTableVA2025 = () => {
  const { testUnderway, allTimeoutsAllowed } = useContext(UserContext);
  return (
      <Row>
        <Col>
          <h5 id="instructions">Instructional Steps</h5>
          <Table bordered>
            <thead>
            <tr>
              <td style={{ width: "20%" }}>
                <strong>Notes</strong>
              </td>
              <td style={{ width: "80%" }}>
                <strong>Steps</strong>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <strong>Steps 1 - 2 must be completed before moving on to 3-6.</strong>
              </td>
              <td>
                <strong>Step 1:</strong> Download and print the list of the Test Patients, then proceed to Step 2.
                <br /><br />
                <strong>Step 2:</strong> Enter the Test Patients into your hospital's production environment (or a test environment that mirrors your production environment exactly), then go back to the Tool to confirm the completion of Step 2 and proceed to Step 3 before the limit ends.
              </td>
            </tr>
            <tr>
              <td>
                <strong>Steps 3 - 6 must be completed for the test to be scored.
                  <br /><br /><br /><br />
                  Important Note: We recommend scheduling at least 45 minutes to perform Step 5.
                </strong>
                </td>
              <td>
                <strong>Step 3:</strong> Download and print the Orders and Observations Sheets, then proceed to Step 4.
                <br /><br />
                <strong>Step 4:</strong> Have a prescriber who routinely orders medications through your inpatient EHR system enter and sign the test order(s) assigned to each Test Patient. The prescriber must record any advice or information they receive from the system on the Orders and Observations Sheets and discontinue the test order(s) before moving on to the following order.
                <br /><br />
                Note: Do not record any advice or information on the Orders and Observations Sheets that may have been sent directly to a pharmacist.
                <br /><br />
                Once advice or information for each of the Test Orders has been recorded on the sheet, go back to the Tool to confirm completion of Step 4 and proceed to Step 5.
                <br /><br />
                <strong>Step 5:</strong> Record the Orders and Observations Sheets responses onto the Online Answer Form, review the Online Answer Form for accuracy and completeness, and submit the Online Answer Form.
                <br /><br />
                <strong>Step 6:</strong> Complete and submit the Affirmation.{" "}
                <br /><br />
                <strong>IMPORTANT NOTICE: </strong>If you close the browser before submitting the Affirmation, you cannot return to the Test without assistance from the EHR/CPOE Staff, and your hospital will receive a score of "Incomplete Evaluation."
              </td>
            </tr>
            <tr>
              <td><strong>&nbsp;</strong></td>
              <td>
                <strong>Step 7:</strong> View and print your results.
              </td>
            </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
  );
};

export default InstructionsTableVA2025;